import React from 'react';
import './App.css'; // Assuming your CSS file

const Service3Second = () => {
    return (
        <div className="about-events-main-container"> {/* Main outer container */}
            <div className="about-events-container2">
                <div className="about-events-wrapper"> {/* Flexbox container */}
                    <div className="about-events-content2">
                        <h2 className="about-header-service2">Special Event Package Details</h2>
                        <p className="about-events-description2">
                            Celebrate your <strong>Birthday Party, Anniversary Celebration, Hen's Party, Office Celebration</strong>, and
                            <strong> all the special moments in your life</strong> with us!
                            Enjoy our exclusive package that includes:
                        </p>

                        <ul className="about-events-list2">
                        <h2 className="about-subheader-service2">Exclusive Package Includes:</h2>
                            <li>- Minimum Pax: <strong>30 persons (weekday) and 50 persons (weekend)</strong></li>
                            <li>- Free <strong>DJ</strong> to keep the party alive</li>
                            <li>- Complimentary <strong>Welcome Drink</strong> for all guests</li>
                            <li>- <strong>Compulsory Room</strong> for your comfort and privacy</li>
                            <li>- Access to the <strong>Swimming Pool</strong> for a refreshing experience</li>
                            <li>- Delicious <strong>Buffet</strong> with a variety of dishes</li>
                            <li>- And for groups of 50 or more, enjoy a <strong>free DJ </strong>to keep the energy high! </li>
                        </ul>
                    </div>

                    <div className="about-events-grid2">
                        <div className="about-events-images2">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/special3.webp`}
                                className="service2-images3"
                               
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Service3Second;
